<template>
  <div :class="componentClass">
    <p>{{ widgetInfo.widgetDescription }}</p>

    <div class="row mb-4 no-gutters text-center">
      <div class="col-sm-12">
        <img class="upload-example" width="100%" height="auto" src="../../assets/import-user-example.svg" alt="Required Information: First Name, Last Name, Email, User Role (Format: camel case w/ no spaces)" title="Required Information: First Name, Last Name, Email, User Role">
        <small>Example: <span style="color: #BB0000;">*Required Information</span> & Data Formatting</small>
      </div>
    </div>

    <div class="row no-gutters text-center">
      <div class="col-sm-12">
        <button class="btn btn-primary">
          <i class="fas fa-file-download"></i>
          <span class="ml-1" @click="exportCSV">Download Template</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { createCSVTemplate } from '../../services/csvHandlers';

export default {
  props: ['widgetInfo'],
  data() {
    return {
      isLoading: false,
    };
  },
  computed: {
    componentClass() {
      return `${this.widgetInfo.widgetName}-block`;
    },
    userList: {
      get() {
        return this.$store.state.importUsers.userList;
      },
      set() {
        // this.$store.commit('updateUserList', value); // TODO: Set store value
      },
    },
  },
  methods: {
    exportCSV() {
      createCSVTemplate();
    },
  },
};
</script>

<style scoped>
/**WIDGET STYLING**/
.card.no-padding,
.card.no-padding .card-body {
  padding: 0 !important;
}

/**WIDGET LOADING ANIMATION**/
.widget-loader .loader-content{
  position: absolute;
  top: 37%;
  left: 0;
  right: 0;
  max-width: 150px;
  min-width: 150px;
  padding: 0.5rem;
  margin: auto;
  color: #3674B2;
  background:rgba(255,255,255, 0.8);
  border-radius: 0.25rem;
}

/**IMPORT USERS**/
/**IMPORT USER FILE EXAMPLE IMAGE**/
img.upload-example {
  width: 100% !important;
  height: inherit !important;
}
</style>
<style>
i.fa-circle-o-notch:before{
  content: "\f1ce";
  font-family: "Font Awesome 5 Pro", "Font Awesome 5 Free";
  color: #3674B2;
}
</style>



// WEBPACK FOOTER //
// src/components/presentational/DownloadfileBlock.vue?fcdba40e